import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Image, Checkbox } from '@gik/ui';

export interface ICalendarServiceTileProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  image: string;

  selected?: boolean;
  horizontal?: boolean;
  multiple?: boolean;
}

export function CalendarServiceTile({
  image,
  label,
  selected,
  horizontal,
  multiple,

  className,
}: ICalendarServiceTileProps) {
  const bem = bemBlock('calendar-service-tile');

  return (
    <div className={bem(null, [{ horizontal }, { vertical: !horizontal }, { selected }], className)}>
      <Image className={bem('image')} src={image} />
      <span className={bem('label')}>{label}</span>

      {multiple && <Checkbox checked={selected} />}
    </div>
  );
}
